import React from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ApartmentIcon from '@mui/icons-material/Apartment';
import BusinessIcon from '@mui/icons-material/Business';
import {PropertyType} from 'src/apis/autoGenerate/types/apartment';

interface PropertyTypeSelectionModalProps {
  open: boolean;
  onClose: () => void;
  onSelectPropertyType: (propertyType: PropertyType) => void;
}

export default function PropertyTypeSelectionModal({
  open,
  onClose,
  onSelectPropertyType,
}: PropertyTypeSelectionModalProps) {
  const propertyTypes = [
    {
      type: PropertyType.MULTI_FAMILY,
      title: 'Multi-Family',
      description: 'Residential properties with multiple units',
      icon: <ApartmentIcon sx={{fontSize: 48, color: '#1976d2'}} />,
    },
    {
      type: PropertyType.COMMERCIAL,
      title: 'Commercial',
      description: 'Commercial properties and business spaces',
      icon: <BusinessIcon sx={{fontSize: 48, color: '#1976d2'}} />,
    },
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Select Property Type</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" sx={{mb: 3}}>
          Choose the type of property you want to create
        </Typography>
        <Grid container spacing={3}>
          {propertyTypes.map(propertyType => (
            <Grid item xs={12} md={6} key={propertyType.type}>
              <Card
                sx={{
                  cursor: 'pointer',
                  transition: 'all 0.2s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 3,
                  },
                  border: '1px solid #e0e0e0',
                  borderRadius: 2,
                }}
                onClick={() => onSelectPropertyType(propertyType.type)}
              >
                <CardContent sx={{textAlign: 'center', py: 4}}>
                  <Box sx={{mb: 2}}>{propertyType.icon}</Box>
                  <Typography variant="h6" sx={{mb: 1, fontWeight: 600}}>
                    {propertyType.title}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {propertyType.description}
                  </Typography>
                  <Button
                    variant="outlined"
                    sx={{mt: 2, borderRadius: 20}}
                    onClick={e => {
                      e.stopPropagation();
                      onSelectPropertyType(propertyType.type);
                    }}
                  >
                    Select
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
